import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { LanguageContext } from "../context/LanguageContext";
// import { useAuth } from "../context/auth";
// import { OverlayTrigger, Tooltip } from "react-bootstrap";

const footerAll = {
  english: {
    termText: `Terms of use`,
    helpText: `Help`,
    followText: `Follow us`,
    privacyText: `Privacy Policy`,
    cookiesText: `Cookies Policy`,
  },
  italiano: {
    termText: `Termini e Condizioni`,
    helpText: `Supporto`,
    followText: `Seguici`,
    privacyText: `Privacy`,
    cookiesText: `Cookie`,
  },
  deutsch: {
    termText: `AGB`,
    helpText: `Support`,
    followText: `Folge uns`,
    privacyText: `Datenschutz`,
    cookiesText: `Cookies`,
  },
  español: {
    termText: `Términos y condiciones`,
    helpText: `Soporte`,
    followText: `Síguenos`,
    privacyText: `Privacidad`,
    cookiesText: `Cookies`,
  },
  francais: {
    termText: `Conditions générales`,
    helpText: `Support`,
    followText: `Suivez-nous`,
    privacyText: `Confidentialité`,
    cookiesText: `Cookies`,
  },
  nihongo: {
    termText: `利用規約`,
    helpText: `サポート`,
    followText: `フォローする`,
    privacyText: `プライバシー`,
    cookiesText: `クッキー`,
  },
  nederlands: {
    termText: `Gebruiksvoorwaarden`,
    helpText: `Hulp`,
    followText: `Volg ons`,
    privacyText: `Privacybeleid`,
    cookiesText: `Cookiebeleid`,
  },
  chinese: {
    termText: `使用条款`,
    helpText: `帮助`,
    followText: `关注我们`,
    privacyText: `隐私政策`,
    cookiesText: `Cookie政策`,
  },
};
const Footer = () => {
  // const [auth] = useAuth();
  const { selectedLanguage } = useContext(LanguageContext);

  return (
    <>
      <div
        className=" d-flex mobiddle hfoter px-sm-5 px-3  justify-content-between gapmart align-items-center pt-2 "
        style={{ backgroundColor: "#F2F2F2", height: "150px" }}
      >
        <div className="px-md-5 flxdrc ">
          <div>
            <Link
              to="/terms"
              className="text-decoration-none     fw-normal fontmobil fs-6"
              style={{
                color: "#202020",
                fontFamily: "Open Sans",

                lineHeight: "34.98px",
              }}
            >
              {/* Terms of use */}
              {footerAll[selectedLanguage]?.termText}
            </Link>
          </div>
          <div>
            <Link
              to="/privacy"
              className="text-decoration-none  fontmobil fs-6 fw-normal"
              style={{
                color: "#202020",

                lineHeight: "34.98px",
              }}
            >
              {footerAll[selectedLanguage]?.privacyText || "Privacy Policy"}
            </Link>
          </div>
          <div>
            <Link
              to="/cookies"
              className="text-decoration-none  fw-normal fontmobil fs-6"
              style={{
                color: "#202020",

                lineHeight: "34.98px",
              }}
            >
              {footerAll[selectedLanguage]?.cookiesText || "Cookies Policy"}
            </Link>
          </div>

          <div>
            <Link
              to="/help"
              className="text-decoration-none  fw-normal fontmobil fs-6"
              style={{
                color: "#202020",

                lineHeight: "34.98px",
              }}
            >
              {/* Help */}
              {footerAll[selectedLanguage]?.helpText}
            </Link>
          </div>
          {/* <div>
            {auth?.user ? (
              <Link
                to="/help"
                className="text-decoration-none fontmobil fs-5"
                style={{
                  color: "#202020",
                  fontFamily: "Open Sans",
                  fontWeight: "600",
                  lineHeight: "34.98px",
                }}
              >
                Help
              </Link>
            ) : (
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip id="tooltip-login">Please login first</Tooltip>
                }
              >
                <span
                  className="text-decoration-none fw600 fontmobil fs-5"
                  style={{
                    color: "#202020",

                    lineHeight: "34.98px",
                    cursor: "pointer",
                  }}
                >
                  Help
                </span>
              </OverlayTrigger>
            )}
          </div> */}
        </div>

        {/* <div
          className="fs-5 ftzcopy mt-sm-4"
          style={{
            color: "#202020",
            fontFamily: "Open Sans",
            fontWeight: "600",
            lineHeight: "34.98px",
          }}
        >
          &copy; 2025 Ofellio
        </div> */}

        <div className="mt-2 px-md-5">
          <img
            className=" w-sm-100  mlogowidthfoter "
            src={require("../components/image/footerlogo.png")}
            alt="logo"
          />
        </div>
      </div>
    </>
  );
};

export default Footer;
